import { PulseTourConfig, PulseTourStep } from '@go-modules/services/go-pulse-tour/go-pulse-tour.service';

const TOUR_KEY = 'ai-comment-composer-tour';
const TOUR_STEPS: PulseTourStep[] =  [
	{
		completeSelectors: ['.comment-composer-btn'],
		pulse: {
			selectors: ['.comment-composer-btn']
		}
	}
];

export const COMMENT_COMPOSER_TOUR_CONFIG: PulseTourConfig = {
	viewTrackKey: TOUR_KEY,
	steps: TOUR_STEPS,
	constraints: {
		tourStartDate: new Date('2025-06-09'),
		isOnboarding: false
	}
};
